import type { AllPublicationItem } from '../../shared/api/all-publications.api';

/**
 * Пост «Всей ленты» для карточки публикации. Отдельной ручки «пост по id»
 * у ленты нет, и карточка жила только на location.state: перезагрузка или
 * ссылка из чата давали «Публикация не найдена». Кладём пост в sessionStorage
 * при переходе — карточка переживает F5 в той же вкладке.
 */
const KEY = (mediaId: string) => `if:feed-item:${mediaId}`;

export function stashFeedItem(item: AllPublicationItem): void {
  try {
    sessionStorage.setItem(KEY(item.mediaId), JSON.stringify(item));
  } catch {
    // Нет хранилища — останется только state перехода.
  }
}

export function readStashedFeedItem(mediaId: string | undefined): AllPublicationItem | null {
  if (!mediaId) return null;
  try {
    const raw = sessionStorage.getItem(KEY(mediaId));
    return raw ? (JSON.parse(raw) as AllPublicationItem) : null;
  } catch {
    return null;
  }
}
